import React from 'react';

// Hooks
import { useState } from 'react';

// Interfaces
import { Patient } from '../interfaces/Patient';
import { PhysiologicalDataCase } from '../interfaces/PhysiologicalMonitoring';

// PatientsContext: handles the PatientsContext
const PatientsContext = React.createContext<{
    patients: Patient[], setPatients: React.Dispatch<React.SetStateAction<Patient[]>>,
    physiologicalData: PhysiologicalDataCase[], setPhysiologicalData: React.Dispatch<React.SetStateAction<PhysiologicalDataCase[]>>,
}
>({
    patients: [], setPatients: () => undefined,
    physiologicalData: [], setPhysiologicalData: () => undefined,
});

export const PatientsContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    // state of the total patients
    const [patients, setPatients] = useState<Patient[]>([]);

    // received physiologicalData
    const [physiologicalData, setPhysiologicalData] = useState<PhysiologicalDataCase[]>([]);

    const initState = {
        patients, setPatients,
        physiologicalData, setPhysiologicalData,
    };

    return (
        <PatientsContext.Provider value={initState}>
            {children}
        </PatientsContext.Provider>
    );
};
export default PatientsContext;
